import { 
    Form, 
    Input, 
    Modal, 
    Select, 
    Button, 
    Tag, 
    Tooltip, 
    Spin,
    notification,
    Space,
    Divider,
    Typography,
    Row,
    Col,
    Card,
    DatePicker,
    InputNumber
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import { 
    EditOutlined, 
    DeleteOutlined, 
    PlusOutlined,
    BookOutlined,
    DollarOutlined,
    UserOutlined,
    BankOutlined,
    FileTextOutlined,
    SaveOutlined,
    CloseOutlined,
    TagsOutlined,
    CalendarOutlined,
    GlobalOutlined,
    ProfileOutlined
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import moment from "moment";
import { getAuthorRequest, getCategoryRequest, getPublisherRequest } from "../../redux/controller";
import { useDispatchRoot, useSelectorRoot } from "../../redux/store";
import BookApi from '../../api/book/book.api';
import './CModalEditBook.styles.scss';
import { confirmCloseModal } from './CModalConfirmClose';
import TagsSelector from '../TagsSelector/TagsSelector';

const { Text, Title } = Typography;
const { Option } = Select;

interface MyProps {
    open: boolean;
    data?: any;
    isDetailLoading?: boolean;
    setOpenModalEdit: React.Dispatch<React.SetStateAction<boolean>>;
    onUpdated?: () => Promise<void> | void;
    layout?: 'single' | 'grid';
}

type LayoutType = Parameters<typeof Form>[0]['layout'];

const CModalEditBook = (props: MyProps) => {
    const [selectTitle, setSelectTitle] = useState("");
    const [selectPrice, setSelectPrice] = useState(0);
    const [selectCategories, setSelectCategories] = useState<any[]>([]);
    const [selectAuthors, setSelectAuthors] = useState<any[]>([]);
    const [selectPublisher, setSelectPublisher] = useState<string>("");
    const [selectDescription, setSelectDescription] = useState<string>("");
    const [formLayout, setFormLayout] = useState<LayoutType>('horizontal');
    const [isLoading, setIsLoading] = useState(false);
    const [hasChanges, setHasChanges] = useState(false);
    const [charCount, setCharCount] = useState(0);
    const [previewImage, setPreviewImage] = useState<string>("");
    const [selectedTags, setSelectedTags] = useState<number[]>([]);
    
    const { listCategory, listAuthor, listPublisher } = useSelectorRoot((state) => state.management);
    const dispatch = useDispatchRoot();
    const [form] = Form.useForm();
    const formItemLayout = formLayout === 'horizontal' ? { labelCol: { span: 6 }, wrapperCol: { span: 18 } } : null;
    const [windowSize, setWindowSize] = useState([window.innerWidth, window.innerHeight]);
    const values = Form.useWatch([], form);
    const [checkForm, setCheckForm] = useState(false);
    const checkButton = (checkForm && selectAuthors.length > 0 && selectCategories.length > 0 && !!selectPublisher);

    const layout = props.layout || 'single';

    useEffect(() => {
        dispatch(getCategoryRequest());
        dispatch(getAuthorRequest());
        dispatch(getPublisherRequest());
    }, []);

    useEffect(() => {
        if (props.open && props.data) {
            console.log("Modal Edit Book - props.data:", props.data);
            console.log("Modal Edit Book - categoriesBooks:", props.data.categoriesBooks);
            console.log("Modal Edit Book - authorsBooks:", props.data.authorsBooks);
            console.log("Modal Edit Book - publishingHouse:", props.data.publishingHouse);
            
            // Xử lý categories - thử nhiều cấu trúc khác nhau
            let categoryIds: any[] = [];
            if (props.data.categoriesBooks && Array.isArray(props.data.categoriesBooks)) {
                categoryIds = props.data.categoriesBooks.map((category: any) => 
                    category.category?.id || category.id
                );
            } else if (props.data.categories && Array.isArray(props.data.categories)) {
                categoryIds = props.data.categories.map((category: any) => 
                    category.id || category
                );
            }
            
            // Xử lý authors - thử nhiều cấu trúc khác nhau
            let authorIds: any[] = [];
            if (props.data.authorsBooks && Array.isArray(props.data.authorsBooks)) {
                authorIds = props.data.authorsBooks.map((author: any) => 
                    author.author?.id || author.id
                );
            } else if (props.data.authors && Array.isArray(props.data.authors)) {
                authorIds = props.data.authors.map((author: any) => 
                    author.id || author
                );
            }
            
            // Xử lý publisher
            let publisherId = "";
            if (props.data.publishingHouse?.id) {
                publisherId = props.data.publishingHouse.id;
            } else if (props.data.publisher?.id) {
                publisherId = props.data.publisher.id;
            } else if (props.data.publisherId) {
                publisherId = props.data.publisherId;
            } else if (props.data.publishing_house_id) {
                publisherId = props.data.publishing_house_id;
            }
            
            console.log("Modal Edit Book - categoryIds:", categoryIds);
            console.log("Modal Edit Book - authorIds:", authorIds);
            console.log("Modal Edit Book - publisherId:", publisherId);
            
            setSelectCategories(categoryIds);
            setSelectAuthors(authorIds);
            setSelectPublisher(publisherId);
            setSelectDescription(props.data.description || "");
            setCharCount(props.data.description?.length || 0);
            setSelectedTags((props.data.tags || []).map((tag: any) => tag.id || tag));
            
            form.setFieldsValue({
                title: props.data.name || props.data.title,
                price: props.data.pricePaper || props.data.price,
                priceEbook: props.data.priceEbook || 0,
                priceAudio: props.data.priceAudio || 0,
                amount: props.data.amount ?? 50,
                ISBN: props.data.ISBN || "",
                language: props.data.language || "vietnamese",
                pageNumber: props.data.pageNumber || 0,
                releaseDate: props.data.releaseDate ? moment(props.data.releaseDate) : null,
                size: props.data.size || "",
                description: props.data.description,
                categories: categoryIds,
                authors: authorIds,
                publisher: publisherId,
                tags: (props.data.tags || []).map((tag: any) => tag.id || tag),
            });
        }
    }, [props.open, props.data?.id, props.data?.updatedAt]);

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowSize([window.innerWidth, window.innerHeight]);
        };

        window.addEventListener("resize", handleWindowResize);
        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    });

    useEffect(() => {
        form.validateFields({ validateOnly: true }).then(
            () => {
                setCheckForm(true);
            },
            () => {
                setCheckForm(false);
            }
        );
    }, [values]);

    useEffect(() => {
        const currentValues = form.getFieldsValue();
        const originalTagIds = (props.data?.tags || []).map((t: any) => t.id || t);
        const hasFormChanges = 
            currentValues.title !== props.data?.name ||
            currentValues.price !== props.data?.pricePaper ||
            currentValues.description !== props.data?.description ||
            selectCategories.length !== props.data?.categoriesBooks?.length ||
            selectAuthors.length !== props.data?.authorsBooks?.length ||
            selectPublisher !== props.data?.publishingHouse?.id ||
            JSON.stringify([...selectedTags].sort()) !== JSON.stringify([...originalTagIds].sort());
        
        setHasChanges(hasFormChanges);
    }, [values, selectCategories, selectAuthors, selectPublisher, selectedTags]);

    const handleChangeCategory = (event: any) => {
        setSelectCategories(event);
    };

    const handleChangeAuthor = (event: any) => {
        setSelectAuthors(event);
    };

    const handleChangePublisher = (event: any) => {
        setSelectPublisher(event);
    };

    const handleDescriptionChange = (e: any) => {
        const value = e.target.value;
        setCharCount(value.length);
        setSelectDescription(value);
    };

    const formatCurrency = (value: string) => {
        if (!value) return '';
        const number = parseInt(value.replace(/\D/g, ''));
        return number.toLocaleString('vi-VN');
    };

    const handlePriceChange = (e: any) => {
        const value = e.target.value;
        const formatted = formatCurrency(value);
        form.setFieldsValue({ price: formatted });
    };

    const handleEditBook = async () => {
        setIsLoading(true);
        try {
            const rawPrice = form.getFieldsValue().price;
            const priceStr = typeof rawPrice === 'number' ? String(rawPrice) : (rawPrice || '');
            const parsedPrice = parseInt(priceStr.replace(/\D/g, ''), 10);

            if (isNaN(parsedPrice)) {
                notification.error({
                    message: 'Lỗi',
                    description: 'Giá sách không hợp lệ',
                    placement: 'topRight',
                });
                setIsLoading(false);
                return;
            }

            const toNumberIds = (ids: any[]) =>
                (ids || [])
                    .map((id) => Number(id))
                    .filter((id) => Number.isFinite(id));

            const values = form.getFieldsValue();
            const bodyRequest = {
                id: props.data?.id,
                name: values.title,
                pricePaper: parsedPrice,
                priceEbook: Number(values.priceEbook || 0),
                priceAudio: Number(values.priceAudio || 0),
                amount: Number(values.amount ?? 50),
                ISBN: values.ISBN || "",
                language: values.language || "vietnamese",
                pageNumber: Number(values.pageNumber || 0),
                releaseDate: values.releaseDate ? values.releaseDate.toISOString() : undefined,
                size: values.size || "",
                description: values.description || "",
                publishing_house_id: Number(selectPublisher),
                authorIds: toNumberIds(selectAuthors),
                categoryIds: toNumberIds(selectCategories),
            };
            
            await BookApi.editBook(props.data?.id, bodyRequest).toPromise();

            notification.success({
                message: 'Thành công',
                description: 'Cập nhật sách thành công',
                placement: 'topRight',
            });

            await props.onUpdated?.();
            props.setOpenModalEdit(false);
        } catch (error) {
            console.error('Error updating book:', error);
            notification.error({
                message: 'Lỗi',
                description: 'Có lỗi xảy ra khi cập nhật sách',
                placement: 'topRight',
            });
        } finally {
            setIsLoading(false);
        }
    };

    const handleCancelEditBook = () => {
        confirmCloseModal({
            hasChanges,
            onConfirm: () => {
                resetForm();
                props.setOpenModalEdit(false);
            },
            title: 'Xác nhận đóng',
            content: 'Bạn có thay đổi chưa lưu. Bạn có chắc chắn muốn đóng modal chỉnh sửa sách?'
        });
    };

    const resetForm = () => {
        setSelectPublisher("");
        setSelectAuthors([]);
        setSelectCategories([]);
        setSelectedTags([]);
        setHasChanges(false);
        setCharCount(0);
        form.resetFields();
    };

    const getFullNameAuthor = (author: any) => {
        if (author.name) return author.name;
        let fullName = "";
        if (author.firstName) fullName += author.firstName;
        if (author.middleName) fullName += " " + author.middleName;
        if (author.lastName) fullName += " " + author.lastName;
        return fullName.trim() || `Tác giả #${author.id}`;
    };

    const renderSingleColumnLayout = () => (
        <Form
            form={form}
            layout="vertical"
            className="edit-book-form"
            initialValues={props.data}
        >
            <Row gutter={[16, 12]}>
                <Col span={24}>
                    <Form.Item
                        label={
                            <Space>
                                <BookOutlined />
                                <span>Tên sách</span>
                            </Space>
                        }
                        name="title"
                        rules={[{ required: true, message: 'Vui lòng nhập tên sách' }]}
                    >
                        <Input
                            placeholder="Nhập tên sách"
                            size="middle"
                            className="form-input"
                        />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label={
                            <Space>
                                <DollarOutlined />
                                <span>Giá (VNĐ)</span>
                            </Space>
                        }
                        name="price"
                        rules={[
                            { required: true, message: 'Vui lòng nhập giá sách' },
                            { pattern: /^[0-9,]+$/, message: 'Giá không hợp lệ' }
                        ]}
                    >
                        <Input
                            placeholder="0"
                            size="middle"
                            className="form-input"
                            onChange={handlePriceChange}
                            suffix="VNĐ"
                        />
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label={
                            <Space>
                                <BankOutlined />
                                <span>Nhà xuất bản</span>
                            </Space>
                        }
                        name="publisher"
                        rules={[{ required: true, message: 'Vui lòng chọn nhà xuất bản' }]}
                    >
                        <Select
                            placeholder="Chọn nhà xuất bản"
                            size="middle"
                            className="form-select"
                            onChange={handleChangePublisher}
                            value={selectPublisher}
                            showSearch
                            filterOption={(input, option) => {
                                const label = option?.label || option?.children;
                                return String(label).toLowerCase().includes(input.toLowerCase());
                            }}
                        >
                            {listPublisher.map((publisher) => (
                                <Option key={publisher.id} value={publisher.id}>
                                    {publisher.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label={
                            <Space>
                                <UserOutlined />
                                <span>Tác giả</span>
                            </Space>
                        }
                        name="authors"
                        rules={[{ required: true, message: 'Vui lòng chọn tác giả' }]}
                    >
                        <Select
                            mode="multiple"
                            placeholder="Chọn tác giả"
                            size="middle"
                            className="form-select"
                            onChange={handleChangeAuthor}
                            value={selectAuthors}
                            showSearch
                            filterOption={(input, option) => {
                                const label = option?.label || option?.children;
                                return String(label).toLowerCase().includes(input.toLowerCase());
                            }}
                            tagRender={(props) => (
                                <Tag
                                    closable={props.closable}
                                    onClose={props.onClose}
                                    className="custom-tag"
                                >
                                    {props.label}
                                </Tag>
                            )}
                        >
                            {listAuthor.map((author) => (
                                <Option key={author.id} value={author.id}>
                                    {getFullNameAuthor(author)}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={12}>
                    <Form.Item
                        label={
                            <Space>
                                <BookOutlined />
                                <span>Thể loại</span>
                            </Space>
                        }
                        name="categories"
                        rules={[{ required: true, message: 'Vui lòng chọn thể loại' }]}
                    >
                        <Select
                            mode="multiple"
                            placeholder="Chọn thể loại"
                            size="middle"
                            className="form-select"
                            onChange={handleChangeCategory}
                            value={selectCategories}
                            showSearch
                            filterOption={(input, option) => {
                                const label = option?.label || option?.children;
                                return String(label).toLowerCase().includes(input.toLowerCase());
                            }}
                            tagRender={(props) => (
                                <Tag
                                    closable={props.closable}
                                    onClose={props.onClose}
                                    className="custom-tag"
                                >
                                    {props.label}
                                </Tag>
                            )}
                        >
                            {listCategory.map((category) => (
                                <Option key={category.id} value={category.id}>
                                    {category.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><GlobalOutlined /><span>Ngôn ngữ</span></Space>}
                        name="language"
                        rules={[{ required: true, message: 'Vui lòng chọn ngôn ngữ' }]}
                    >
                        <Select placeholder="Chọn ngôn ngữ" size="middle" className="form-select">
                            <Option value="vietnamese">Tiếng Việt</Option>
                            <Option value="english">Tiếng Anh</Option>
                            <Option value="french">Tiếng Pháp</Option>
                            <Option value="chinese">Tiếng Trung</Option>
                            <Option value="japanese">Tiếng Nhật</Option>
                        </Select>
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><FileTextOutlined /><span>Số trang</span></Space>}
                        name="pageNumber"
                    >
                        <InputNumber min={0} placeholder="Số trang" size="middle" className="form-input" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><CalendarOutlined /><span>Ngày phát hành</span></Space>}
                        name="releaseDate"
                    >
                        <DatePicker format="YYYY-MM-DD" placeholder="Chọn ngày" size="middle" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><FileTextOutlined /><span>Kích thước</span></Space>}
                        name="size"
                    >
                        <Input placeholder="VD: 14x20cm" size="middle" className="form-input" />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><DollarOutlined /><span>Giá ebook</span></Space>}
                        name="priceEbook"
                    >
                        <InputNumber min={0} placeholder="VND" size="middle" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><DollarOutlined /><span>Giá audio</span></Space>}
                        name="priceAudio"
                    >
                        <InputNumber min={0} placeholder="VND" size="middle" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>

                <Col span={8}>
                    <Form.Item
                        label={<Space><ProfileOutlined /><span>Số lượng kho</span></Space>}
                        name="amount"
                        rules={[{ required: true, message: 'Vui lòng nhập số lượng' }]}
                    >
                        <InputNumber min={0} placeholder="50" size="middle" style={{ width: '100%' }} />
                    </Form.Item>
                </Col>

                <Col span={16}>
                    <Form.Item
                        label={<Space><BookOutlined /><span>Mã ISBN</span></Space>}
                        name="ISBN"
                    >
                        <Input placeholder="Mã ISBN (tùy chọn)" size="middle" className="form-input" />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label={
                            <Space>
                                <TagsOutlined />
                                <span>Tags</span>
                            </Space>
                        }
                        name="tags"
                    >
                        <TagsSelector
                            value={selectedTags}
                            onChange={setSelectedTags}
                            bookId={props.data?.id}
                            placeholder="Chọn tags cho sách"
                        />
                    </Form.Item>
                </Col>

                <Col span={24}>
                    <Form.Item
                        label={
                            <Space>
                                <FileTextOutlined />
                                <span>Mô tả sách</span>
                            </Space>
                        }
                        name="description"
                        rules={[
                            { required: true, message: 'Vui lòng nhập mô tả sách' },
                            { max: 3000, message: 'Mô tả không được quá 3000 ký tự' }
                        ]}
                    >
                        <TextArea
                            placeholder="Nhập mô tả chi tiết về sách..."
                            rows={10}
                            className="form-textarea description-textarea"
                            style={{ minHeight: 180, height: 180 }}
                            onChange={handleDescriptionChange}
                            showCount
                            maxLength={3000}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );

    const renderGridLayout = () => (
        <Row gutter={[24, 16]}>
            <Col xs={24} lg={16}>
                <Form
                    form={form}
                    layout="vertical"
                    className="edit-book-form"
                    initialValues={props.data}
                >
                    <Row gutter={[16, 12]}>
                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BookOutlined />
                                        <span>Tên sách</span>
                                    </Space>
                                }
                                name="title"
                                rules={[{ required: true, message: 'Vui lòng nhập tên sách' }]}
                            >
                                <Input
                                    placeholder="Nhập tên sách"
                                    size="middle"
                                    className="form-input"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label={
                                    <Space>
                                        <DollarOutlined />
                                        <span>Giá (VNĐ)</span>
                                    </Space>
                                }
                                name="price"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập giá sách' },
                                    { pattern: /^[0-9,]+$/, message: 'Giá không hợp lệ' }
                                ]}
                            >
                                <Input
                                    placeholder="0"
                                    size="middle"
                                    className="form-input"
                                    onChange={handlePriceChange}
                                    suffix="VNĐ"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BankOutlined />
                                        <span>Nhà xuất bản</span>
                                    </Space>
                                }
                                name="publisher"
                                rules={[{ required: true, message: 'Vui lòng chọn nhà xuất bản' }]}
                            >
                                <Select
                                    placeholder="Chọn nhà xuất bản"
                                    size="middle"
                                    className="form-select"
                                    onChange={handleChangePublisher}
                                    value={selectPublisher}
                                    showSearch
                                    filterOption={(input, option) => {
                                        const label = option?.label || option?.children;
                                        return String(label).toLowerCase().includes(input.toLowerCase());
                                    }}
                                >
                                    {listPublisher.map((publisher) => (
                                        <Option key={publisher.id} value={publisher.id}>
                                            {publisher.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label={
                                    <Space>
                                        <UserOutlined />
                                        <span>Tác giả</span>
                                    </Space>
                                }
                                name="authors"
                                rules={[{ required: true, message: 'Vui lòng chọn tác giả' }]}
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Chọn tác giả"
                                    size="middle"
                                    className="form-select"
                                    onChange={handleChangeAuthor}
                                    value={selectAuthors}
                                    showSearch
                                    filterOption={(input, option) => {
                                        const label = option?.label || option?.children;
                                        return String(label).toLowerCase().includes(input.toLowerCase());
                                    }}
                                    tagRender={(props) => (
                                        <Tag
                                            closable={props.closable}
                                            onClose={props.onClose}
                                            className="custom-tag"
                                        >
                                            {props.label}
                                        </Tag>
                                    )}
                                >
                                    {listAuthor.map((author) => (
                                        <Option key={author.id} value={author.id}>
                                            {getFullNameAuthor(author)}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item
                                label={
                                    <Space>
                                        <BookOutlined />
                                        <span>Thể loại</span>
                                    </Space>
                                }
                                name="categories"
                                rules={[{ required: true, message: 'Vui lòng chọn thể loại' }]}
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Chọn thể loại"
                                    size="middle"
                                    className="form-select"
                                    onChange={handleChangeCategory}
                                    value={selectCategories}
                                    showSearch
                                    filterOption={(input, option) => {
                                        const label = option?.label || option?.children;
                                        return String(label).toLowerCase().includes(input.toLowerCase());
                                    }}
                                    tagRender={(props) => (
                                        <Tag
                                            closable={props.closable}
                                            onClose={props.onClose}
                                            className="custom-tag"
                                        >
                                            {props.label}
                                        </Tag>
                                    )}
                                >
                                    {listCategory.map((category) => (
                                        <Option key={category.id} value={category.id}>
                                            {category.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col span={24}>
                            <Form.Item
                                label={
                                    <Space>
                                        <TagsOutlined />
                                        <span>Tags</span>
                                    </Space>
                                }
                                name="tags"
                            >
                                <TagsSelector
                                    value={selectedTags}
                                    onChange={setSelectedTags}
                                    bookId={props.data?.id}
                                    placeholder="Chọn tags cho sách"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>

            <Col xs={24} lg={8}>
                <Card 
                    title={
                        <Space>
                            <FileTextOutlined />
                            <span>Mô tả sách</span>
                        </Space>
                    }
                    className="description-card"
                >
                    <Form.Item
                        name="description"
                        rules={[
                            { required: true, message: 'Vui lòng nhập mô tả sách' },
                            { max: 1000, message: 'Mô tả không được quá 1000 ký tự' }
                        ]}
                    >
                        <TextArea
                            placeholder="Nhập mô tả chi tiết về sách..."
                            rows={8}
                            className="form-textarea"
                            onChange={handleDescriptionChange}
                            showCount
                            maxLength={1000}
                        />
                    </Form.Item>
                    
                    <div className="char-count">
                        <Text type="secondary">{charCount}/1000 ký tự</Text>
                    </div>
                </Card>
            </Col>
        </Row>
    );

    return (
        <Modal
            open={props.open}
            title={
                <Space>
                    <EditOutlined />
                    <span>Chỉnh sửa sách</span>
                </Space>
            }
            onCancel={handleCancelEditBook}
            footer={null}
            width={layout === 'grid' ? 1100 : 900}
            className="edit-book-modal"
            destroyOnClose
            maskClosable={true}
        >
            <Spin spinning={isLoading || !!props.isDetailLoading} tip={props.isDetailLoading ? "Đang tải dữ liệu sách..." : "Đang cập nhật..."}>
                <div className="modal-content">
                    {layout === 'single' ? renderSingleColumnLayout() : renderGridLayout()}
                    
                    <Divider style={{ margin: '16px 0' }} />
                    
                    <div className="modal-actions">
                        <Button
                            onClick={handleCancelEditBook}
                            className="cancel-button"
                            icon={<CloseOutlined />}
                        >
                            Hủy
                        </Button>
                        <Button
                            type="primary"
                            onClick={handleEditBook}
                            loading={isLoading}
                            className="save-button"
                            icon={<SaveOutlined />}
                        >
                            Cập nhật
                        </Button>
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};

export default CModalEditBook;
